import { render, staticRenderFns } from "./a3.vue?vue&type=template&id=0795c454&scoped=true&"
import script from "./a3.vue?vue&type=script&lang=js&"
export * from "./a3.vue?vue&type=script&lang=js&"
import style0 from "./a3.vue?vue&type=style&index=0&id=0795c454&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0795c454",
  null
  
)

export default component.exports